import React from 'react';
import NumberFormat from 'react-number-format';

export const ThongTinTrungViLuong = (props) => {

    const ShowEdit = () => {
        props.showEditThongTin();
    }

    return (
        <div className="thong-tin">
            {
                props.thongTin.tenHuyen ? <table className="table table-bordered" width="100%">
                    <thead>
                        <tr>
                            <th colSpan="2"> Bản đồ trung vi lượng
                            {
                                    props.admin ? <button type="button" className="btn btn-primary btn-sm suathongtin" onClick={ShowEdit}><i className='fas fa-edit'></i></button> : ''
                                }
                            </th>
                        </tr>
                        <tr>
                            <th className="col-name">Tên</th>
                            <th>Thông tin</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="col-name">Tỉnh</td>
                            <td>{props.thongTin?.tenTinh}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Huyện</td>
                            <td>{props.thongTin?.tenHuyen}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Xã</td>
                            <td>{props.thongTin?.tenXa}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Diện tích(ha)</td>
                            <td>
                                <NumberFormat value={props.thongTin?.dienTich} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat>
                            </td>
                        </tr>
                        <tr>
                            <td className="col-name">Mã TVL</td>
                            <td>{props.thongTin?.maTrungViLuong}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Chế Canxi</td>
                            <td>{props.thongTin?.maCa}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Magiê</td>
                            <td>{props.thongTin?.maMg}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Silic</td>
                            <td>{props.thongTin?.ma_tsSi}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Sắt di động</td>
                            <td>{props.thongTin?.ma_ddFe}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Molypđen</td>
                            <td>{props.thongTin?.ma_dtMo}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Mangan</td>
                            <td>{props.thongTin?.ma_tdMn}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Bo hòa tan</td>
                            <td>{props.thongTin?.ma_htBo}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Kẽm dễ tiêu</td>
                            <td>{props.thongTin?.ma_dtZn}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Đồng dễ tiêu</td>
                            <td>{props.thongTin?.ma_dtCu}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Lưu huỳnh hòa tan</td>
                            <td>{props.thongTin?.ma_htS}</td>
                        </tr>
                    </tbody>
                </table> : <h5 className="text-center">Không có thông tin</h5>
            }
        </div>
    )
};